export default {
  name: 'app-footer'
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-footer.js